<template>
  <input
    ref="input"
    :placeholder="placeholder"
    :value="_value"
    :disabled="disabled"
    class="date-input"
    @click="$emit('click')"
    @blur="$emit('blur')"
    @paste="handlePaste"
  >
</template>

<script>
  import Cleave from 'cleave.js';
  import moment from 'moment';
  import getLocaleParams from 'utils/calendar/calendarLocaleParams';
  import {dateFormatter} from 'components/Inputs/Dates/utils/dateformatter';

  export default {
    name: 'DateInput',
    props: {
      value: {
        type: Date,
        default: ''
      },
      placeholder: {
        type: String,
        default: ''
      },
      disabled: {
        type: Boolean,
        default: false
      }
    },
    data () {
      return {
        cleave: null
      };
    },
    computed: {
      calendarLocaleParams () {
        return getLocaleParams('calendarParams');
      },
      _value () {
        if (!this.value) {
          return '';
        }
        const d = {
          d: String(this.value.getDate()).padStart(2, '0'),

          // +1 because months are in range [0, 11]
          m: String(this.value.getMonth() + 1).padStart(2, '0'),
          Y: String(this.value.getFullYear().toString().
            substr(-2)).padStart(2, '0')
        };
        const dateArray = this.calendarLocaleParams.dateInputPattern.map(i => d[i]);
        return dateArray.join(this.calendarLocaleParams.dateInputDelimiter);
      }
    },
    mounted () {
      this.initMask();
      this.$on('hook:beforeDestroy', () => {
        this.destroyMask();
      });
    },
    methods: {
      initMask () {
        const date = new Date();
        const year = date.getFullYear() + 100;
        this.cleave = new Cleave(this.$el, {
          date: true,
          delimiter: this.calendarLocaleParams.dateInputDelimiter,
          datePattern: this.calendarLocaleParams.dateInputPatternShort,
          dateMin: '1990-01-01',
          dateMax: `${year}-01-01`,
          onValueChanged: this.handleInput
        });
      },
      destroyMask () {
        if (this.cleave) {
          this.cleave.destroy();
        }
      },
      handleInput (e, date = null) {
        const formattedVal = date || e.target.value;
        if (formattedVal.length === 8) {
          const momentDate = moment(formattedVal, dateFormatter.momentDateFormatShort());
          if (momentDate.isValid()) {
            this.$emit('input', momentDate.toDate());
          }
        }
      },
      handlePaste (e) {
        const text = (e.clipboardData || window.clipboardData).getData('text');

        // support date format with full year `dd-mm-yyyy`
        if (text.length === 10) {
          const checkDate = moment(text, dateFormatter.momentDateFormat());
          if (checkDate.isValid()) {

            // prevent default paste and convert 10-symbol format to short format and start "on-paste callback"
            e.preventDefault();
            const pasteDate = checkDate.format(dateFormatter.momentDateFormatShort());
            this.$refs.input.value = pasteDate;
            this.handleInput({}, pasteDate);
          }
        }
      }
    }
  };
</script>

<style>
  input.date-input {
    line-height: unset;
  }

</style>
